export default __webpack_public_path__ + "static/media/Athletics Track, PKL-1.81b814ea.jpg";